export default function setDetailChange(field, value, prefix) {
	return (dispatch) => {
		dispatch({
			type: 'SET_DETAIL_CHANGE',
			payload: {field, value, prefix},
		});
	};
}